/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PutOrgAutoModelRequest = {
  endpoint: components.AutoEndpoint;
  putOrgAutoModelRequest: components.PutOrgAutoModelRequest;
};

/** @internal */
export const PutOrgAutoModelRequest$inboundSchema: z.ZodType<
  PutOrgAutoModelRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  endpoint: components.AutoEndpoint$inboundSchema,
  PutOrgAutoModelRequest: components.PutOrgAutoModelRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "PutOrgAutoModelRequest": "putOrgAutoModelRequest",
  });
});
/** @internal */
export type PutOrgAutoModelRequest$Outbound = {
  endpoint: string;
  PutOrgAutoModelRequest: components.PutOrgAutoModelRequest$Outbound;
};

/** @internal */
export const PutOrgAutoModelRequest$outboundSchema: z.ZodType<
  PutOrgAutoModelRequest$Outbound,
  z.ZodTypeDef,
  PutOrgAutoModelRequest
> = z.object({
  endpoint: components.AutoEndpoint$outboundSchema,
  putOrgAutoModelRequest: components.PutOrgAutoModelRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    putOrgAutoModelRequest: "PutOrgAutoModelRequest",
  });
});

export function putOrgAutoModelRequestToJSON(
  putOrgAutoModelRequest: PutOrgAutoModelRequest,
): string {
  return JSON.stringify(
    PutOrgAutoModelRequest$outboundSchema.parse(putOrgAutoModelRequest),
  );
}
export function putOrgAutoModelRequestFromJSON(
  jsonString: string,
): SafeParseResult<PutOrgAutoModelRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PutOrgAutoModelRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PutOrgAutoModelRequest' from JSON`,
  );
}
